// extracted by mini-css-extract-plugin
export default {"root":"EdMH8t","onImage":"kFjtai"};